import { UILabel, UICollectionViewCell } from "uikit";

export class HeaderCell extends UICollectionViewCell
{
    private titleLabel:UILabel = null;
    private _title: string = null ;

    awakeFromNib ( )
    {      
        this.updateUI( ) ;
    }
    
    set title ( name: string )
    {
      this._title = name ;
      this.updateUI( ) ;
    }

    private updateUI ( )
    {
      this.titleLabel.text = this._title ;
    }
}